import React from "react";

// material imports
import { Box, Divider, Grid2, Typography } from "@mui/material";

// project imports
import FooterLogo from "../assets/suwa-arana-footer-logo.png";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";

const Footer = () => {
  const handleRedirect = () => {
    window.location.href = "https://suwaarana.org/";
  };

  const handleLocation = () => {
    window.location.href = "https://maps.app.goo.gl/d6y2bTSTWAtTRj8XA";
  };

  const phoneNumber1 = "+94112363211";
  const phoneNumber2 = "+94112850414";
  const email = "info@suwaarana.org";

  return (
    <Box sx={{ bgcolor: "#F3E2E6", height: { xs: 650, md: 450 } }}>
      <Grid2
        container
        spacing={2}
        justifyContent="center"
        sx={{
          flexDirection: { xs: "column", md: "row" },
          alignItems: { xs: "center", md: "flex-start" },
        }}
      >
        {/* Footer Logo Section */}
        <Grid2
          item
          size={{ xs: 12, md: 8.2 }}
          id="fotter-logo-section"
          sx={{ textAlign: { xs: "center", md: "left" } }}
        >
          <Box onClick={handleRedirect} sx={{ mt: 6.8, cursor: "pointer" }}>
            <img src={FooterLogo} alt="Suwa Arana Logo" height="150" />
          </Box>
        </Grid2>

        {/* Footer Contact Details Section - Moves below Logo on small screens */}
        <Grid2
          item
          size={{ xs: 12, md: 8.2 }}
          id="footer-contact-details-section"
          sx={{
            textAlign: { xs: "center", md: "right" },
            mt: { xs: 2, md: -20 },
          }}
        >
          <Typography
            variant="button"
            sx={{ fontWeight: "semibold", fontSize: 20, letterSpacing: 2 }}
          >
            Contact Us
          </Typography>

          <Box
            sx={{
              display: "flex",
              justifyContent: { xs: "center", md: "flex-end" },
              mt: 2,
            }}
          >
            <LocationOnIcon sx={{ color: "#8B2757", fontSize: 20 }} />
            <Typography
              variant="h5"
              sx={{ ml: 1, fontSize: 16, color: "#8B2757", cursor: "pointer" }}
              onClick={handleLocation}
            >
              Suwa Arana
            </Typography>
          </Box>

          <Box sx={{ textAlign: { xs: "center", md: "right" }, mt: 1 }}>
            <Typography
              variant="body2"
              sx={{ color: "gray", fontSize: 15, lineHeight: 1.7 }}
            >
              63, Hospital Road, <br /> Maharagama, <br /> Sri Lanka
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: { xs: "center", md: "flex-end" },
              mt: 2,
            }}
          >
            <LocalPhoneIcon sx={{ color: "#8B2757", fontSize: 20 }} />
            <Typography
              variant="subtitle2"
              sx={{ ml: 1.5, fontSize: 14, color: "#8B2757" }}
            >
              <a
                href={`tel:${phoneNumber1}`}
                style={{ color: "#8B2757", textDecoration: "none" }}
              >
                {phoneNumber1} from (7AM - 7PM)
              </a>
              <br />
              <a
                href={`tel:${phoneNumber2}`}
                style={{ color: "#8B2757", textDecoration: "none" }}
              >
                {phoneNumber2} from (9AM - 5PM)
              </a>
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: { xs: "center", md: "flex-end" },
              mt: 3,
            }}
          >
            <EmailIcon sx={{ color: "#8B2757", fontSize: 18 }} />
            <Typography
              variant="h5"
              sx={{ ml: 1.5, fontSize: 16, color: "gray" }}
            >
              <a
                href={`mailto:${email}`}
                style={{ color: "#8B2757", textDecoration: "none" }}
              >
                {email}
              </a>
            </Typography>
          </Box>
        </Grid2>

        <Divider sx={{ mt: 3, width: "100%" }} />

        {/* Footer Copyright Section */}
        <Grid2
          item
          size={{ xs: 12, md: 8.2 }}
          id="footer-copyright-section"
          sx={{ textAlign: { xs: "center", md: "start" }, mt: 2 }}
        >
          <Typography variant="subtitle2" sx={{ fontSize: 12, color: "gray" }}>
            © 2019 - 2025 Suwa Arana. All rights reserved
          </Typography>
        </Grid2>

        {/* Footer Developer Section - Moves below Copyright on small screens */}
        <Grid2
          item
          size={{ xs: 12, md: 8.2 }}
          id="footer-developer-section"
          sx={{
            textAlign: { xs: "center", md: "end" },
            mt: { xs: 0.5, md: -5 },
          }}
        >
          <Typography
            variant="body2"
            sx={{ fontFamily: "revert", fontSize: 12, color: "gray" }}
          >
            Developed & Maintained by IF Solutions
          </Typography>
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default Footer;
